import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class FactionMpProvider {
  // Информация о фракции
  public static async getGeneralInformation(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionGetGeneralInformationResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetGeneralInformationRequest,
      typeof RegionShared.Backend.Responses.FactionGetGeneralInformationResponse
    >(RegionShared.Backend.Events.Faction.GetGeneralInformation, {});
  }

  // Коллеги - Участники / отделы
  public static async getMembers(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionGetMembersResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetMembersRequest,
      typeof RegionShared.Backend.Responses.FactionGetMembersResponse
    >(RegionShared.Backend.Events.Faction.GetMembers, {});
  }

  // Коллеги - ЧС
  public static async getBlacklist(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionGetBlacklistResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetBlacklistRequest,
      typeof RegionShared.Backend.Responses.FactionGetBlacklistResponse
    >(RegionShared.Backend.Events.Faction.GetBlacklist, {});
  }

  // Коллеги - Заявки
  public static async getIntroductionRequests(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionGetIntroductionRequestsResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetIntroductionRequestsRequest,
      typeof RegionShared.Backend.Responses.FactionGetIntroductionRequestsResponse
    >(RegionShared.Backend.Events.Faction.GetIntroductionRequests, {});
  }

  // Данные о пользователе
  public static async getMember(
    memberId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionGetMemberResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetMemberRequest,
      typeof RegionShared.Backend.Responses.FactionGetMemberResponse
    >(RegionShared.Backend.Events.Faction.GetMember, { memberId });
  }

  // Информация о рангах
  public static async getRanks(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionGetRanksResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGetRanksRequest,
      typeof RegionShared.Backend.Responses.FactionGetRanksResponse
    >(RegionShared.Backend.Events.Faction.GetRanks, {});
  }

  // Выйти из фракции
  public static async leave(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionLeaveResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionLeaveRequest,
      typeof RegionShared.Backend.Responses.FactionLeaveResponse
    >(RegionShared.Backend.Events.Faction.Leave, {});
  }

  // Повысить ранк (себя)
  public static async upgradeRank(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionUpgradeRankResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionUpgradeRankRequest,
      typeof RegionShared.Backend.Responses.FactionUpgradeRankResponse
    >(RegionShared.Backend.Events.Faction.UpgradeRank, {});
  }

  // Изменить ранк (члена фракции - повысить/понизить)
  public static async upDownRank(
    memberId: number,
    direction: 1 | -1,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionChangeMemberRankResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionChangeMemberRankRequest,
      typeof RegionShared.Backend.Responses.FactionChangeMemberRankResponse
    >(RegionShared.Backend.Events.Faction.ChangeMemberRank, { memberId, direction });
  }

  // Исключить из фракции
  public static async fireMember(
    memberId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionFireMemberResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionFireMemberRequest,
      typeof RegionShared.Backend.Responses.FactionFireMemberResponse
    >(RegionShared.Backend.Events.Faction.FireMember, { memberId });
  }

  // Изменение ранга
  public static async changeMemberRank(
    memberId: number,
    direction: -1 | 1,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionChangeMemberRankResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionChangeMemberRankRequest,
      typeof RegionShared.Backend.Responses.FactionChangeMemberRankResponse
    >(RegionShared.Backend.Events.Faction.ChangeMemberRank, { memberId, direction });
  }

  // Выдать премию
  public static async giveAward(
    memberId: number,
    amount: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionGiveAwardResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionGiveAwardRequest,
      typeof RegionShared.Backend.Responses.FactionGiveAwardResponse
    >(RegionShared.Backend.Events.Faction.GiveAward, { memberId, amount });
  }

  // Добавить в черный список
  public static async addToBlacklist(
    characterId: number,
    reason: string,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionAddToBlacklistResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionAddToBlacklistRequest,
      typeof RegionShared.Backend.Responses.FactionAddToBlacklistResponse
    >(RegionShared.Backend.Events.Faction.AddToBlacklist, { characterId, reason });
  }

  // Убрать из черного списка
  public static async removeFromBlacklist(
    characterId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionRemoveFromBlacklistResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionRemoveFromBlacklistRequest,
      typeof RegionShared.Backend.Responses.FactionRemoveFromBlacklistResponse
    >(RegionShared.Backend.Events.Faction.RemoveFromBlacklist, { characterId });
  }

  // Изменение отдела
  public static async changeMemberDepartment(
    memberId: number,
    departmentId: number | null,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionChangeMemberDepartmentResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionChangeMemberDepartmentRequest,
      typeof RegionShared.Backend.Responses.FactionChangeMemberDepartmentResponse
    >(RegionShared.Backend.Events.Faction.ChangeMemberDepartment, { memberId, departmentId });
  }

  // Изменение должности
  public static async changeMemberRankPosition(
    memberId: number,
    rankPositionId: number | null,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionChangeMemberRankPositionResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionChangeMemberRankPositionRequest,
      typeof RegionShared.Backend.Responses.FactionChangeMemberRankPositionResponse
    >(RegionShared.Backend.Events.Faction.ChangeMemberRankPosition, { memberId, rankPositionId });
  }

  // Отказ заявки на вступление
  public static async removeIntroductionRequest(
    characterId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.FactionRemoveIntroductionRequestResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionRemoveIntroductionRequestRequest,
      typeof RegionShared.Backend.Responses.FactionRemoveIntroductionRequestResponse
    >(RegionShared.Backend.Events.Faction.RemoveIntroductionRequest, { characterId });
  }

  // Изменение доступов
  public static async changePermissions(
    rankId: number,
    name?: string,
    accesses?: {
      [key: string]: boolean;
    },
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.FactionChangeRankResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.FactionChangeRankRequest,
      typeof RegionShared.Backend.Responses.FactionChangeRankResponse
    >(RegionShared.Backend.Events.Faction.ChangeRank, { rankId, name, accesses });
  }
}
